import type { CustomerCreditsStore } from './interfaces'

export const actions = {
  setProgram (this: CustomerCreditsStore, payload: CustomerCreditsStore['program']): void {
    this.program = payload
  },
  setReferrals (this: CustomerCreditsStore, payload: CustomerCreditsStore['referrals']): void {
    this.referrals = payload
  },
  setReferralsMeta (this: CustomerCreditsStore, payload: CustomerCreditsStore['referralsMeta']): void {
    this.referralsMeta = payload
  },
  setReferralsLoading (this: CustomerCreditsStore, payload: CustomerCreditsStore['referralsLoading']): void {
    this.referralsLoading = payload
  },
  setTransactions (this: CustomerCreditsStore, payload: CustomerCreditsStore['transactions']): void {
    this.transactions = payload
  },
  setTransactionsMeta (this: CustomerCreditsStore, payload: CustomerCreditsStore['transactionsMeta']): void {
    this.transactionsMeta = payload
  },
  setTransactionsLoading (this: CustomerCreditsStore, payload: CustomerCreditsStore['transactionsLoading']): void {
    this.transactionsLoading = payload
  },
  setProcessing (this: CustomerCreditsStore, payload: CustomerCreditsStore['processing']): void {
    this.processing = payload
  },
  setModalEdit (this: CustomerCreditsStore, payload: CustomerCreditsStore['modalEdit']): void {
    this.modalEdit = payload
  },
  reset (this: CustomerCreditsStore): void {
    this.program = null
    this.referrals = []
    this.referralsMeta = null
    this.transactions = []
    this.transactionsMeta = null
    this.modalEdit = false
  },
}
